import { render } from "./MultipleQuestion.vue?vue&type=template&id=35361e26&scoped=true&ts=true"
import script from "./MultipleQuestion.vue?vue&type=script&lang=ts"
export * from "./MultipleQuestion.vue?vue&type=script&lang=ts"

import "./style.scss?vue&type=style&index=0&id=35361e26&lang=scss&scoped=true"
import "./MultipleQuestion.vue?vue&type=style&index=1&id=35361e26&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/deployJob/project/music-teach/h5-internal-examination/code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35361e26"]])

export default __exports__